import EndcapCoverFlowPage from "@faire/prototype-playground/workspace/ah/endcap-cover-flow";
import { Route, Switch } from "react-router-dom";

export function AlierHuRoutes() {
  return (
    <Switch>
      <Route path="/ah/endcap-cover-flow" component={EndcapCoverFlowPage} />
    </Switch>
  );
}

export const slug = "ah";
